module.exports = __webpack_public_path__ + "static/media/staff4.3314e95e.png";